/**
 * Created by robert.lavoie on 6/21/17.
 */

import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable ,  of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Services
import { SiteService } from './site.service';


@Injectable()
export class JobDetailResolver implements Resolve<any> {

  constructor(private siteService: SiteService, private http: HttpClient, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    return this.http.get(`${this.siteService.getApiUrl()}/jobs/${route.paramMap.get('id')}`).pipe(
      catchError((error: any) => {
        // Capture all error except Job detail 404s
        if (error.status !== 404){
          this.router.navigate(['/']);
        }

        return of(null);
      }));

  }
}
